<template>
  <App>
    <form
        class="form d-flex flex-column flex-lg-row fv-plugins-bootstrap5 fv-plugins-framework"
        novalidate="novalidate"
        @submit.prevent="submit"
    >
      <form-body :loading="form.processing || loading" :form="form">
        <projeto-form :form="form" editing></projeto-form>
      </form-body>
    </form>
  </App>
</template>

<script>
import {Link, useForm} from "@inertiajs/inertia-vue3";
import App from "@layout/App";
import Datatable from "@forms/Datatable";
import SubmitButton from "@forms/SubmitButton";
import FormGroup from "@forms/FormGroup";
import FormBody from "@forms/FormBody";
import ProjetoForm from "./ProjetoForm";

import {error} from "@settings/toastr";
import {ref} from "vue";

export default {
  props: ['projeto'],

  components: {
    FormBody,
    FormGroup,
    SubmitButton,
    App,
    Link,
    Datatable,
    ProjetoForm
  },
  mounted() {
    this.init();
  },

  setup(props) {
    const form = useForm({...props.projeto})
    return {form};
  },

  data: _ => ({
    loading: false,
  }),

  methods: {
    init() {
      this.emitter.emit('title', 'Edita Inscrição');

      this.emitter.emit('breadcrumb', [
        {title: 'Dashboard', link: 'app.home'},
        {title: 'Projetos', link: 'app.projetos.index'},
        {title: 'Edita inscrição'},
      ]);

      this.emitter.emit('action', {
            show: true,
            icon: 'bi-arrow-left-short',
            title: 'Voltar',
            link: this.route('app.projetos.index')
          }
      );
    },

    submit() {
      this.form.post(this.route('app.projetos.update', this.form.id), {
        onError: error
      });
    },
  }
};
</script>
